import { motion } from 'framer-motion';
import SidebarGalleryPage from '../Main/Sidebargallery';
import Myimage from "../../assets/Career&Guidence/tnp_banner.jpg"

const trainingInfo = {
  intro: "GWPCS is equipped with distinguished professors having vast experience to nurture the talent of students. The experience of the acclaimed faculties will help transform students into better citizens of the future.",
  courses: [
    "Entrepreneur training by DIC",
    "Practical training for office management by DSJDW",
    "Industrial visit AKASHVANI Bhopal",
    "Cyber security Training provide by MPCON",
    "Soft Skill development program by SGBS UNNATI Foundation",
    "Java Programming by IGTR Indore",
    "Computer Hardware and Networking by IGTR Indore",
    "Workshop on Internet of Things by INDEYES Bhopal",
  ],

}


export default function CareerDevCellSection() {
  return (
    <div className="min-h-screen bg-gray-100 p-14">
      <div className="flex flex-col lg:flex-row gap-10">
        {/* Main Content */}
        <motion.div
          className="lg:col-span-2 "
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <img
            src={Myimage}
            alt="Career Guidance & Placement Cell Banner"
            className="w-full rounded-lg border-4 border-teal-500 p-2 mb-10"
          />

          {/* <hr className="mt-7 mb-2 border-t border-dotted border-gray-400" /> */}

          <div className="border-4 border-teal-500 p-2 rounded-lg">
            <h2 className="text-xl font-bold mb-4 text-white bg-teal-500 p-2 rounded-sm">
              Training and Placement Cell
            </h2>
            <p className="p-2">{trainingInfo.intro}</p>
            <ul className="list-decimal list-inside pl-4">
              {trainingInfo.courses.map((course, index) => (
                <li key={index} className="mb-1">
                  {course}
                </li>
              ))}
            </ul>
            <p className="mt-4 whitespace-pre-line">
              {trainingInfo.additionalInfo}
            </p>
          </div>

          {/* <hr className='mt-8 mb-3'/> */}

          <div className="border-4 border-[#00BFA5] p-2 mt-10 rounded-lg">
            <div>
              <h1 className="text-xl font-bold bg-[#00BFA5] text-white p-2">
                Contact Us
              </h1>
              <div className="p-4">
                <p>Mr. Gajendra Kumar Ahirwar</p>
                <p>Training and Placement Officer</p>
                <p>Mobile: 9926680481</p>
                <p>
                  Email:{" "}
                  <a
                    href="gajendrakumarahirwar@gmail.com"
                    className="text-blue-600 underline"
                  >
                    gajendrakumarahirwar@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Sidebar - Gallery */}
        <SidebarGalleryPage title="gallery"></SidebarGalleryPage>
      </div>
    </div>
  );
}
